// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — indicator.styled.classic.js, новая — indicator.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './indicator.styled.classic';
import * as cp from './indicator.styled.cp';

export const Content = isCp ? cp.Content : classic.Content;
export const IndicatorActive = isCp ? cp.IndicatorActive : classic.IndicatorActive;
